<template>
  <div id="app">
    <!-- 可以被缓存的视图组件 -->
    <keep-alive v-if="this.$route.meta.keepAlive">
      <router-view></router-view>
    </keep-alive>
    <!-- 不可以被缓存的视图组件 -->
    <router-view v-else-if="!$route.meta.keepAlive"></router-view>
    <!-- ai助手 -->
    <!-- <div
      v-if="$store.state.tokenCode && $route.path !== '/register' && $route.path !== '/register1' && $route.path !== '/aiAssistant' && $store.state.projectName !== '新陆'"
      @click="toAiAssistant" @mousedown="startDrag" class="aiAssistant-box flex align"
      :style="{ left: isDragging || !isStickedToRight ? aiAssistantPosition.left + 'px' : 'auto', right: !isDragging && isStickedToRight ? 0 : 'auto', top: aiAssistantPosition.top + 'px' }">
      <div class="aiAssistant-text">Hi，我是AI助手康康
        点我进行AI辅助学习</div>
      <img class="aiAssistant-icon" src="@/assets/AI/iconAssistant.png" alt="">
    </div> -->
  </div>
</template>
<script>
import store from "./store";
export default {
  data() {
    return {
      aiAssistantPosition: {
        left: window.innerWidth - 100, // 初始位置在右下角
        top: window.innerHeight - 150
      },
      isDragging: false,
      hasDragged: false, // 是否发生了拖动
      dragStart: {
        x: 0,
        y: 0
      },
      aiAssistantSize: {
        width: 94,
        height: 94
      },
      isStickedToRight: true // 是否贴在右侧
    };
  },
  mounted() {
    this.$router.push("/guidePage");
  },
  created() {
    this.resizeFun();
  },
  methods: {
    resizeFun() {
      let docEle = document.documentElement,
        resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
        resizeFun = () => {
          let clientWidth = docEle.clientWidth;
          if (!clientWidth) return;
          // 100是换算系数，相当于1rem=100px
          //1920是作为设计图的基准，我这是按照1920*1080的分辨率，可自行修改
          docEle.style.fontSize = 192 * (clientWidth / 1920) + "px";
        };
      if (!document.addEventListener) return;
      window.addEventListener(resizeEvt, resizeFun, false);
      window.addEventListener("DOMContentLoaded", resizeFun, false);
      resizeFun();
    },
    // 开始拖动
    startDrag(e) {
      console.log(e)
      e.stopPropagation();
      this.isDragging = true;
      this.hasDragged = false;
      // 拖动开始时，如果贴在右侧，需要更新left值以保持位置不变
      if (this.isStickedToRight) {
        this.$set(this.aiAssistantPosition, 'left', window.innerWidth - this.aiAssistantSize.width);
      }

      // 获取元素的当前位置
      const rect = e.currentTarget.getBoundingClientRect();
      console.log(rect);

      // 计算鼠标在元素内的偏移量（不考虑边框）
      this.dragStart.x = e.clientX - rect.left;
      this.dragStart.y = e.clientY - rect.top;

      // 移除过渡效果，使拖动更流畅
      e.currentTarget.style.transition = 'none';

      // 添加事件监听器到document
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.stopDrag);

      // 阻止默认行为
      e.preventDefault();
    },
    // 拖动中
    handleMouseMove(e) {
      if (!this.isDragging) return;

      // 标记已经发生拖动
      this.hasDragged = true;

      // 计算新位置（使用鼠标当前位置减去偏移量）
      const newLeft = e.clientX - this.dragStart.x;
      const newTop = e.clientY - this.dragStart.y;
      console.log(newLeft, newTop);

      // 直接更新位置，不使用Vue的响应式更新以提高性能
      this.$set(this.aiAssistantPosition, 'left', newLeft);
      this.$set(this.aiAssistantPosition, 'top', newTop);
    },
    // 停止拖动
    stopDrag() {
      if (!this.isDragging) return;

      this.isDragging = false;

      // 获取AI助手元素
      const aiAssistantBox = document.querySelector('.aiAssistant-box');

      // 恢复过渡效果
      if (aiAssistantBox) {
        aiAssistantBox.style.transition = 'width 0.3s ease-in-out, border-radius 0.3s ease-in-out, left 0.3s ease-in-out, top 0.3s ease-in-out';
      }

      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.stopDrag);

      // 计算窗口尺寸
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      // 只计算左右两边的距离
      const distanceToLeft = this.aiAssistantPosition.left;
      const distanceToRight = windowWidth - (this.aiAssistantPosition.left + this.aiAssistantSize.width);

      // 找到左右两边中最近的边
      if (distanceToLeft < distanceToRight) {
        // 贴到左边
        this.$set(this.aiAssistantPosition, 'left', 0);
        this.isStickedToRight = false;
      } else {
        // 贴到右边
        this.isStickedToRight = true;
      }

      // 检查上下边缘，如果超出则贴边
      if (this.aiAssistantPosition.top < 0) {
        // 超出上边缘，贴到顶部
        this.$set(this.aiAssistantPosition, 'top', 0);
      } else if (this.aiAssistantPosition.top + this.aiAssistantSize.height > windowHeight) {
        // 超出下边缘，贴到底部
        this.$set(this.aiAssistantPosition, 'top', windowHeight - this.aiAssistantSize.height);
      }
    },
    // 跳转到AI助手首页
    toAiAssistant() {
      // 只有当没有发生拖动时才执行跳转
      if (!this.hasDragged) {
        this.$router.push("/aiAssistant");
      }
      // 重置拖动标志
      this.hasDragged = false;
    },
  },
};
</script>
<style lang="scss">
#app::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}

.aiAssistant-box {
  position: fixed;
  width: 94px;
  height: 94px;
  background: #E1E3EA;
  border-radius: 50%;
  border: 2px solid #364674;
  z-index: 999;
  cursor: pointer;
  transition: width 0.3s ease-in-out, border-radius 0.3s ease-in-out, left 0.3s ease-in-out, top 0.3s ease-in-out;
  display: flex;
  align-items: center;
  user-select: none;
  box-sizing: border-box;
}

.aiAssistant-box:hover {
  width: 327px;
  border-radius: 45px;
}

.aiAssistant-icon {
  position: absolute;
  bottom: 0;
  right: 10px;
  width: 69px;
  height: 108px;
  cursor: move;
}

.aiAssistant-text {
  width: 202px;
  height: 48px;

  font-weight: 400;
  font-size: 20px;
  color: #000000;
  line-height: 24px;
  opacity: 0;
  transform: translateX(20px);
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  text-align: center;
  padding-left: 31px;
  flex-shrink: 0;
}

.aiAssistant-box:hover .aiAssistant-text {
  opacity: 1;
  transform: translateX(0);
}

body,
th,
td {
  margin: 0;
  padding: 0;
}

* {
  margin: 0;
}

image {
  display: block;
}

a {
  text-decoration: none;
}

#app {
  width: 100%;
  height: 100vh;
}

page {
  background-color: #f4f4f4;
}

.pointer {
  cursor: pointer;
}


.flex {
  display: flex;
}

.column {
  flex-direction: column;
}

.align {
  align-items: center;
}

.justify {
  justify-content: center;
}

.spaceBetween {
  justify-content: space-between;
}
</style>
